<div class="flex w-full">
    <div class="px-7"></div>
    <button [attr.data-active]="active()" class="text-sm *:text-sm">
        <ng-content />
    </button>
</div>
